// ! Each and every plugin needs to be re-exported here in order to facilitate
// ! lazy loading of editor and plugins by clients.
import AnalyticsPlugin from './AnalyticsPlugin';
import BlockActionPlugin from './BlockActionPlugin';
import BlockLinkPlugin from './BlockLinkPlugin';
import BlockquotePlugin from './BlockquotePlugin';
import HintPlugin from './HintPlugin';
import ClipboardPlugin from './ClipboardPlugin';
import CodePlugin from './CodePlugin';
import CollaborationPlugin from './CollaborationPlugin';
import CommandPickerPlugin from './CommandPickerPlugin';
import CommentPlugin from './CommentPlugin';
import CorePlugin from './CorePlugin';
import CrashPlugin from './CrashPlugin';
import DndPlugin from './DndPlugin';
import EmbedPlaceholderPlugin from './EmbedPlaceholderPlugin';
import EmbedPlugin from './EmbedPlugin';
import EmojiPickerPlugin from './EmojiPickerPlugin';
import FilePlugin from './FilePlugin';
import FirstLinePlugin from './FirstLinePlugin';
import FullWidthPlugin from './FullWidthPlugin';
import GutterBlockPlugin from './GutterBlockPlugin';
import HistoryPlugin from './HistoryPlugin';
import ImageGalleryPlugin from './ImageGalleryPlugin';
import ImagePlugin from './ImagePlugin';
import IntegrationTilePlugin from './IntegrationTilePlugin';
import LastLinePlugin from './LastLinePlugin';
import LightboxPlugin from './LightboxPlugin';
import LineBreakPlugin from './LineBreakPlugin';
import LinkPlugin from './LinkPlugin';
import MentionPickerPlugin from './MentionPickerPlugin';
import MentionPlugin from './MentionPlugin';
import NoteLinkPlugin from './NoteLinkPlugin';
import PdfPlugin from './PdfPlugin';
import PlaceholderPlugin from './PlaceholderPlugin';
import RichTextPlugin from './RichTextPlugin';
import HighlightPlugin from './HighlightPlugin';
import SeparatorPlugin from './SeparatorPlugin';
import SyncPlugin from './SyncPlugin';
import TablePlugin from './TablePlugin';
import ToastPlugin from './ToastPlugin';
import DatabasePlugin from './DatabasePlugin';
import TodoPlugin from './TodoPlugin';
import ToolbarPlugin from './ToolbarPlugin';
import TypingPlugin from './TypingPlugin';
import UnknownBlockPlugin from './UnknownBlockPlugin';
import createStore from './utils/createStore';
import makeBlockActionButton from './utils/makeBlockActionButton';
import makeBlockToolbarButton from './utils/makeBlockToolbarButton';
import makeGutterBlock from './DndPlugin/components/DragButton';
import makeInlineToolbarButton from './utils/makeInlineToolbarButton';
import makeToolbarButton, { TOOLBAR_BUTTON_VISIBILITY } from './utils/makeToolbarButton';
import isActiveBlock from './CorePlugin/queries/isActiveBlock'; // Backward compatibility

import isPasteFromMSWord from './ClipboardPlugin/utils/isPasteFromMSWord';
import * as NormalizationHelper from './utils/NormalizationHelper';
import renderMarks from './utils/renderMarks';
import renderBlocks from './utils/renderBlocks';
export default {
  AnalyticsPlugin: AnalyticsPlugin,
  BlockActionPlugin: BlockActionPlugin,
  BlockLinkPlugin: BlockLinkPlugin,
  BlockquotePlugin: BlockquotePlugin,
  HintPlugin: HintPlugin,
  ClipboardPlugin: ClipboardPlugin,
  CodePlugin: CodePlugin,
  CollaborationPlugin: CollaborationPlugin,
  CommandPickerPlugin: CommandPickerPlugin,
  CommentPlugin: CommentPlugin,
  CorePlugin: CorePlugin,
  CrashPlugin: CrashPlugin,
  DatabasePlugin: DatabasePlugin,
  DndPlugin: DndPlugin,
  EmbedPlaceholderPlugin: EmbedPlaceholderPlugin,
  EmbedPlugin: EmbedPlugin,
  EmojiPickerPlugin: EmojiPickerPlugin,
  FilePlugin: FilePlugin,
  FirstLinePlugin: FirstLinePlugin,
  FullWidthPlugin: FullWidthPlugin,
  GutterBlockPlugin: GutterBlockPlugin,
  HistoryPlugin: HistoryPlugin,
  ImageGalleryPlugin: ImageGalleryPlugin,
  ImagePlugin: ImagePlugin,
  IntegrationTilePlugin: IntegrationTilePlugin,
  LastLinePlugin: LastLinePlugin,
  LightboxPlugin: LightboxPlugin,
  LineBreakPlugin: LineBreakPlugin,
  LinkPlugin: LinkPlugin,
  MentionPickerPlugin: MentionPickerPlugin,
  MentionPlugin: MentionPlugin,
  NoteLinkPlugin: NoteLinkPlugin,
  PdfPlugin: PdfPlugin,
  PlaceholderPlugin: PlaceholderPlugin,
  RichTextPlugin: RichTextPlugin,
  HighlightPlugin: HighlightPlugin,
  SeparatorPlugin: SeparatorPlugin,
  SyncPlugin: SyncPlugin,
  TablePlugin: TablePlugin,
  ToastPlugin: ToastPlugin,
  TodoPlugin: TodoPlugin,
  ToolbarPlugin: ToolbarPlugin,
  TypingPlugin: TypingPlugin,
  UnknownBlockPlugin: UnknownBlockPlugin,
  utils: {
    createStore: createStore,
    makeToolbarButton: makeToolbarButton,
    TOOLBAR_BUTTON_VISIBILITY: TOOLBAR_BUTTON_VISIBILITY,
    makeBlockToolbarButton: makeBlockToolbarButton,
    makeBlockActionButton: makeBlockActionButton,
    makeGutterBlock: makeGutterBlock,
    makeInlineToolbarButton: makeInlineToolbarButton,
    isActiveBlock: isActiveBlock,
    isPasteFromMSWord: isPasteFromMSWord,
    NormalizationHelper: NormalizationHelper,
    renderMarks: renderMarks,
    renderBlocks: renderBlocks
  }
};